var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 5.20817C10.345 5.20817 10.6248 5.48799 10.6248 5.83317V10.8332C10.6248 11.1783 10.345 11.4582 9.99984 11.4582C9.65466 11.4582 9.37484 11.1783 9.37484 10.8332V5.83317C9.37484 5.48799 9.65466 5.20817 9.99984 5.20817Z",
    fill: "#8B8B8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 14.1665C10.4601 14.1665 10.8332 13.7934 10.8332 13.3332C10.8332 12.8729 10.4601 12.4998 9.99984 12.4998C9.5396 12.4998 9.1665 12.8729 9.1665 13.3332C9.1665 13.7934 9.5396 14.1665 9.99984 14.1665Z",
    fill: "#8B8B8B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.0415 9.99984C1.0415 5.05229 5.05229 1.0415 9.99984 1.0415C14.9474 1.0415 18.9582 5.05229 18.9582 9.99984C18.9582 14.9474 14.9474 18.9582 9.99984 18.9582C5.05229 18.9582 1.0415 14.9474 1.0415 9.99984ZM9.99984 2.2915C5.74264 2.2915 2.2915 5.74264 2.2915 9.99984C2.2915 14.257 5.74264 17.7082 9.99984 17.7082C14.257 17.7082 17.7082 14.257 17.7082 9.99984C17.7082 5.74264 14.257 2.2915 9.99984 2.2915Z",
    fill: "#8B8B8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayInfo);
export default __webpack_public_path__ + "static/media/grayInfo.c1db27d80208ff7654813e109b0dfacd.svg";
export { ForwardRef as ReactComponent };